import {
  GETLOGINBLOCKLIST_SUCCESS,
  GETLOGINBLOCKLIST_FAILED,
  RESET_GETLOGINBLOCKLIST,
  LOADING_GETLOGINBLOCKLIST,
  NETWORK_ERROR_GETLOGINBLOCKLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetLoginBlockList = () => {
  return { type: RESET_GETLOGINBLOCKLIST };
};

const getLoginBlockList = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GETLOGINBLOCKLIST });
  await partnerServices
    .post("getLoginBlockList", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.status) {
        case 200:
          dispatch(getLoginBlockListsuccess(res.data));
          break;
        default:
          dispatch(getLoginBlockListFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_GETLOGINBLOCKLIST, payload: err });
    });
};
function getLoginBlockListsuccess(data) {
  return {
    type: GETLOGINBLOCKLIST_SUCCESS,
    payload: data,
  };
}
function getLoginBlockListFailed(data) {
  return {
    type: GETLOGINBLOCKLIST_FAILED,
    payload: data,
  };
}

export { resetGetLoginBlockList, getLoginBlockList };
